// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5726648e","457":"3bd7b21d"}[chunkId] + ".chunk.js";
};